
import { useEffect, useState } from 'react';
import { User } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;

    const getSession = async () => {
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) throw sessionError;
        
        if (mounted) {
          setUser(session?.user ?? null);
          setError(null);
        }
      } catch (err) {
        console.error('Error getting session:', err);
        if (mounted) {
          setError(err instanceof Error ? err : new Error('Failed to get session'));
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    // Initial session check
    getSession();

    return () => {
      mounted = false;
    };
  }, []);

  return { user, loading, error };
};
